const Checkout = {
    /** @type {?CheckoutDriver[]} */
    drivers: null,
    /** @type {?string[]} */
    paymentTypes: null,
    /**
     *
     * @param {string} payment_type
     * @returns {?CheckoutDriver[]}
     */
    driversForPaymentType(payment_type) {
        if(!this.drivers) return null
        return this.drivers.filter(
            d => d.paymentTypes.includes(payment_type)
        )
    },
    /**
     * @return {Promise<CheckoutDriver[]>}
     */
    async getDrivers() {
        if(!this.drivers) {

            /** @type {[CheckoutInfo["info"], CheckoutInfo["payment"]]} */
            const [
                info,
                config,
                basket
            ] = await Promise.all([
                CheckoutInfo.inst.preloadSingle("info"),
                CheckoutInfo.inst.preloadSingle("payment"),
                AnyBasket.inst.preloadSingle('content'),
                PaymentItemCollection.inst.preloadSingle('items')
            ])

            let currency = (AnyBasket.inst).currency;

            if(!config) {
                throw new Error("No config found")
            }
            if(!info) {
                throw new Error("No info found")
            }
            /** @type {{[name: string]: CheckoutDriver}} */
            const drivers = {}

            const payment_types = []
            for(const [payment_type, gateway_info] of Object.entries(info)) {
                if(gateway_info && typeof gateway_info == "object") {
                    if( (!gateway_info.currencies || gateway_info.currencies.length == 0 || gateway_info.currencies.includes(currency)) ){
                        payment_types.push(payment_type)
                    }

                    if(!drivers[gateway_info.type]) {
                        const c = CheckoutDriver.byName[gateway_info.type]
                        if(c) {
                            /** @type {CheckoutDriver} */
                            drivers[gateway_info.type] = new c(
                                config.isLive,
                                gateway_info
                            )
                        }
                    }
                    if(drivers[gateway_info.type]) {
                        drivers[gateway_info.type].paymentTypes.push(
                            payment_type
                        )
                    }
                }
            }
            this.paymentTypes = payment_types
            this.drivers = Object.values(drivers)
        }
        return this.drivers
    }
}

class CheckoutDriver {
    /**
     * @type {{[name: string]: typeof CheckoutDriver}}
     */
    static get byName() {
        if(!this._byName) {
            /**
             * @type {{[name: string]: typeof CheckoutDriver}}
             */
            this._byName = {}
        }
        return this._byName
    }
    /**
     * @param {boolean} is_live
     * @param {*} config
     */
    constructor(is_live, config) {
        this.isLive = is_live
        this.config = config
        /** @type {string[]} */
        this.paymentTypes = []
    }
    get offloadedCheckout() {
        return !!this.config.checkoutKey
    }
    /**
     * False if an invoice can be raised without any payment selection
     */
    get requiresSelection() {
        return this.supportsSelection
    }
    /**
     * True if payment must be selected before the checkout process starts
     */
    get requiresImmediateSelection() {
        return this.requiresSelection
    }
    /**
     * False if no payment selection is possible
     */
    get supportsSelection() {
        return true
    }
    /**
     * @param {HTMLElement} checkout_form
     */
    prepareForm(checkout_form) {
        // No action needed
    }
}

class AnyOrderWrapper {
    static get inst() {
        if(!this._inst) {
            if(!this.instClass) {
                throw new Error("No order service loaded!")
            }
            this._inst = new this.instClass()
        }
        return this._inst
    }
    /**
     * @param {typeof AnyOrderWrapperInst} c
     */
    static register(c) {
        this.instClass = c
    }
}

class AnyActiveOrderInst {
    /**
     * @param {?{MD?: string, PaRes?: *}} info
     * @returns {Promise<{error?: *, redirect?: string}>}
     */
    step(info = null) {
        throw new Error("Not implemented")
    }
}

class AnyOrderWrapperInst {
    /**
     *
     * @param {string} basket_ref
     * @param {{[payment_type: string]: string}} payment_selections
     * @param {boolean} [override_payment_selections]
     * @returns {Promise<AnyActiveOrderInst>}
     */
    add(basket_ref, payment_selections, override_payment_selections = false) {
        throw new Error("Not implemented")
    }
}
